import React from 'react'
import Edit from '../../crud/edit'
import fields from './fields'

const EditOrder = props => {
  return (
    <Edit
// @ts-ignore
      title='Edit University'
      fields={fields}
      apiPath={`admin/universities/${props.params.universityId}`}
      successRedirectPath='/settings/universities'
    />
  )
}

export default EditOrder
